import { z } from "zod";
import { InterviewFormatSchema, RecommendationSchema } from "./enums.js";

/** A round / touchpoint on a candidate-on-a-search. Maps to Phase-2 "Meeting" event. */
export const InterviewEntrySchema = z.object({
  id: z.uuid(),
  candidateSearchId: z.uuid(),
  roundName: z.string(),
  dateConducted: z.string().nullable(),
  interviewers: z.array(z.string()),
  format: InterviewFormatSchema.nullable(),
  feedbackNotes: z.string().nullable(),
  recommendation: RecommendationSchema.nullable(),
  /** admin-only; the client read layer NEVER serializes private entries */
  isPrivate: z.boolean(),
  /** provenance seam: manual (v1) | email | transcript (v2) */
  sourceType: z.string().nullable(),
  sourceRef: z.string().nullable(),
  createdAt: z.string(),
});
export type InterviewEntry = z.infer<typeof InterviewEntrySchema>;

export const InterviewCreateSchema = z.object({
  roundName: z.string().min(1),
  dateConducted: z.iso.date().nullish(),
  interviewers: z.array(z.string()).default([]),
  format: InterviewFormatSchema.nullish(),
  feedbackNotes: z.string().nullish(),
  recommendation: RecommendationSchema.nullish(),
  isPrivate: z.boolean().default(false),
});
export type InterviewCreate = z.infer<typeof InterviewCreateSchema>;

export const InterviewUpdateSchema = InterviewCreateSchema.partial();
export type InterviewUpdate = z.infer<typeof InterviewUpdateSchema>;
